"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataRow = void 0;

var react_1 = __importDefault(require("react"));

var ComposedTypo_1 = require("../ComposedTypo");

var react_theme_components_1 = require("@suezenv/react-theme-components");

require("./DataRow.scss");

var clsx_1 = __importDefault(require("clsx"));

var react_device_detect_1 = require("react-device-detect");

exports.DataRow = function (_a) {
  var reference = _a.reference,
      address = _a.address,
      isTerminate = _a.isTerminate,
      className = _a.className,
      resiliationDate = _a.resiliationDate;
  return react_1.default.createElement("div", {
    className: clsx_1.default('d-flex align-items-center flex-wrap', className, {
      'data-row py-3 data-row-padding-left': isTerminate
    })
  }, react_1.default.createElement("div", {
    className: clsx_1.default('row align-items-start', {
      'pl-5 pr-3': isTerminate
    })
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "col-12 col-md-4 col-lg-3"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, 'Référence Client'), reference && react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, {
    variant: 'body'
  }, reference)), react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: clsx_1.default('col-3 d-none d-md-block', isTerminate ? 'col-md-5 col-lg-6' : 'col-md-8 col-lg-9')
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, 'Adresse'), address && react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, {
    variant: 'body'
  }, address)), isTerminate && react_1.default.createElement("div", {
    className: "col-12 col-md-3 col-lg-3"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: react_device_detect_1.isMobile ? 'caption' : 'body',
    weight: "medium",
    className: "text-left text-md-center mt-1 mt-md-3 pt-sm-3 pt-lg-0 pt-xl-0",
    color: "inactive"
  }, resiliationDate ? "R\xE9sili\xE9 le " + resiliationDate : "Résilié"))));
};

exports.default = exports.DataRow;